/**
 * Shared dummy MediaStream for driving WebRTC loopback connections.
 *
 * A small animated canvas provides the carrier signal whose RTP payloads
 * get replaced by the RtpInjectorWorker with real encoded video data.
 * The stream is created once and shared across all WebRTCVideoDecoder instances.
 */
const DUMMY_WIDTH = 320;
const DUMMY_HEIGHT = 180;
const DUMMY_FPS = 60;
let sharedStream = null;
let animationInterval = null;
export function ensureDummyStream() {
    if (sharedStream)
        return sharedStream;
    const canvas = document.createElement('canvas');
    canvas.width = DUMMY_WIDTH;
    canvas.height = DUMMY_HEIGHT;
    const ctx = canvas.getContext('2d');
    if (!ctx)
        throw new Error('Failed to get 2d context for dummy canvas');
    let hue = 0;
    animationInterval = setInterval(() => {
        ctx.fillStyle = `hsl(${hue % 360},50%,20%)`;
        ctx.fillRect(0, 0, DUMMY_WIDTH, DUMMY_HEIGHT);
        hue++;
    }, 8);
    // captureStream provides the RTP carrier frames that the inject worker replaces
    sharedStream = canvas.captureStream(DUMMY_FPS);
    return sharedStream;
}
export function destroyDummyStream() {
    if (animationInterval) {
        clearInterval(animationInterval);
        animationInterval = null;
    }
    if (sharedStream) {
        sharedStream.getTracks().forEach((t) => t.stop());
        sharedStream = null;
    }
}
